// extracted by mini-css-extract-plugin
export var dropdownIcon = "_oq-6";
export var imgContainer = "_oq-3";
export var menuIcon = "_oq-5";
export var pillWrapper = "_oq-2";
export var pillsContainer = "_oq-1";
export var subscriptionCard = "_oq-0";
export var subscriptionLogo = "_oq-4";